import React, { Component, useEffect, useState } from 'react';
import CountUp from 'react-countup';
import { connect } from 'react-redux';
import axios from 'axios';
import { Redirect } from 'react-router-dom';
import { useHistory } from "react-router-dom";

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { API_BASE_URL } from '../../config.js'
import DataTable, { defaultThemes } from 'react-data-table-component';

import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';

import Pagination from '../Pagination/Paginations.js';
import EntriesSelector from '../Pagination/EntriesSelector';
import useSortData from "../Pagination/SortData";

// import DataTable from 'datatables.net-react';
// import DT from 'datatables.net-dt';

// DataTable.use(DT);
import {
    statisticsAction,
    statisticsCloseAction
} from '../../actions/settingsAction.js';
import { Link } from 'react-router-dom/cjs/react-router-dom.min.js';
const HrListPaylip = (props) => {
    const sparkline1 = React.createRef();
    const sparkline2 = React.createRef();
    const sparkline3 = React.createRef();
    const sparkline4 = React.createRef();


    const handleStatistics = (e) => {
        statisticsAction(e)
    }
    const closeStatistics = (e) => {
        statisticsCloseAction(e)
    }

    const { fixNavbar, statisticsOpen, statisticsClose } = props;
    const emptyUser={
        url_name: "",
        url_link: "",
        parent: ""
    }

    const [user, setUser] = useState({
        url_name: "",
        url_link: "",
        parent: ""
    })

    const handelInput = (event) => {
        event.preventDefault();
        const { name, value } = event.target;
        console.log(name, value)
        setUser({ ...user, [name]: value });
    }



    
    const history = useHistory();
    const [data, setData] = useState([]);
    const [datacount, setDataCount] = useState([]);
    const [dataval, setdataval] = useState([]);
    const [currentPageId, setCurrentPageId] = useState(1);
    const { sortConfig, sortData, handleSort } = useSortData();


    const [searchTerm, setSearchTerm] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [entriesPerPage,setEntriesPerPage]=useState(10);
    let filteredItems = data.filter((item) =>



        `${item.employee_id.toLowerCase()}${item.employee_name.toLowerCase()}${item.department_name.toLowerCase()}`.includes(searchTerm.toLowerCase())

    );
    const totalPages = Math.ceil(filteredItems.length / entriesPerPage);
	const indexOfLast = currentPage * entriesPerPage;
	const indexOfFirst = indexOfLast - entriesPerPage;
	// const filteredData = filteredItems.slice(indexOfFirst, indexOfLast);

    const sortedItems = sortData(filteredItems);
	const filteredData = sortedItems.slice(indexOfFirst, indexOfLast);

    useEffect(() => {
        setCurrentPage(1);
    }, [searchTerm]);

    
    const handleSearch = (event) => {
        setSearchTerm(event.target.value);
    };


    const clearInput = () => {
        setSearchTerm("");
      };


  


    const handleUpdate = async (id) => {
            window.open(API_BASE_URL +'/payslip/'+id, '_blank')
    
            // axios.get(API_BASE_URL +'/payslip/'+id, {
            // 	headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
            // })
            // .then(res1 => setUser(res1.data))
            // .catch(err => console.log(err))
           };



    useEffect(() => {
        axios.get(API_BASE_URL + '/hr_payslip_list', {
            headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
        })


            .then(res => setData(res.data))
            // .then(res => console.log(res.data))
            .catch(err => console.log(err));
    }, [])




  

    var elements = [];
    for (var i = 1; i <= datacount.total_page; i++) {
        elements.push(i);
    }

    //   for(var i=1;i<=datacount.total_page;i++){
    // 	elements.push(<li className="page-item"><a className="page-link" href="" onClick={() => handlePagination(i)}>
    // 	  {i}
    //   </a></li>);
    // }






    const columns = [
    { label: "Payment Id", key: "payment_id", sortable: true },
	{ label: "Employee Id", key: "employee_id", sortable: true },
	{ label: "Employee", key: "employee_name", sortable: true },
	{ label: "Department", key: "department_name", sortable: true },
  	{ label: "Payslip Month", key: "month_payment", sortable: true },
	{ label: "Applied On", key: "applied_on", sortable: true },
	{ label: "Reason", key: "reason", sortable: true },
	{ label: "Incharge", key: "incharge_status", sortable: true },
	{ label: "HOD", key: "hod_status", sortable: true },
	{ label: "HR", key: "hr_status", sortable: true },

];





    return (
        <>


            <div>
                <div>
                    <div className={`section-body ${fixNavbar ? "marginTop" : ""} `}>
                        <div className="container-fluid">

                            <ToastContainer />
                            {/* <div className="d-flex justify-content-between align-items-center mb-3">
                                <div className="header-action">
                                    <div id="button">
                                        <button style={{ float: 'center' }}
                                            type="button"
                                            className="btn btn-primary"
                                            data-toggle="modal"
                                            data-target="#exampleModal"
                                            onClick={()=>{setUser(emptyUser)}}
                                        >
                                            <i className="fe fe-plus mr-2" />
                                            Add
                                        </button>
                                    </div>
                                </div>
                            </div> */}

                        </div>
                    </div>


                    <div className="section-body">
                        <div className="container-fluid">
                            <div className="tab-content">
                                <div className="tab-pane fade show active" id="Employee-list" role="tabpanel">
                                    <div className="card">
                                        <div className="card-header">
                                            <h3 className="card-title" style={{ color: '#e96827' }}>List All Payslip Request</h3>
                                            <div className="card-options" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '20px' }}>

                                                <div className="input-group">

                                                    <EntriesSelector style={{
																			padding: '1px',
																			marginRight: '20px',
																			borderRadius: '4px',
																			border: '1px solid #ccc',
																			backgroundColor: '#BCD1DB',display: 'flex', justifyContent: 'left'
																		}}
																		setEntriesPerPage={setEntriesPerPage}
																		setCurrentPage={setCurrentPage}
																		/>

                                                    <div style={{ position: "relative", width: "300px" }}>

                                                    <input
                                                        type="text"
                                                        className="form-control form-control-sm"
                                                        placeholder="Search"
                                                        value={searchTerm}
                                                        onChange={e => {
																setSearchTerm(e.target.value);
																setCurrentPage(1);
																}} 
                                                        style={{
                                                            width: "100%",
                                                            padding: "10px",
                                                            paddingRight: "30px", // Extra space for the clear icon
                                                            boxSizing: "border-box",
                                                          }}
                                                        // style={{ padding: '8px', width: '200px', borderRadius: '4px', border: '1px solid #ccc' }}
                                                    />

 {searchTerm.length>0 && ( 
        <span
          onClick={clearInput}
          style={{
            position: "absolute",
            top: "50%",
            right:"10px",
            transform: "translateY(-50%)",
            cursor: "pointer",
            color: "#aaa",
            fontSize: "18px",
            // marginLeft: '260px !important',
            
          }}
        >
          ✖
        </span>
       )}
        </div>



                                                </div>

                                            </div>
                                        </div>












                                        <div className="card-body">
                                            <div className="table-responsive">
                                                <table className="table table-hover table-striped table-vcenter text-nowrap mb-0">
                                                    <thead>
                                                        <tr>
                                                            <th>Action</th>
                                                            <th>Payslip</th>
                                                            {columns.map((col) => (
																<th
																	key={col.key}
																	onClick={col.sortable ? () => handleSort(col.key) : null}
																	style={{ cursor: col.sortable ? "pointer" : "default" }}
																>
																	{col.label}
																	{col.sortable && (
																sortConfig.key === col.key
																	? (sortConfig.direction === "asc" ? " ▲" : " ▼")
																	: " ⇅"   // <-- DEFAULT SORT ICON
																)}
																	</th>
																))}
                                                        </tr>
                                                    </thead>
                                                    <tbody>



                                                        {
                                                            filteredData.map((hrpayslip, index) => {


                                                                let pdfbtn;

                                                                
                                                                    if(hrpayslip.hr_status_flag==2) 
                                                                    {
                                                                        pdfbtn =<button className='btn' style={{ backgroundColor:'rgb(233 132 143)'}} onClick={() => handleUpdate(hrpayslip.pay_id)}><i class="fa-sharp fa-regular fa-file-pdf fa-2x"></i></button>;
                                                                    }
                                                                    else
                                                                    {
                                                                        pdfbtn='';
                                                                    }

                                                                      

                                                              

                                                                


                                                                return <tr key={index}>
                                                                    <td className="d-flex">

                                                                     {(((hrpayslip.floor_status==2) && (hrpayslip.dept_status==2)) && (hrpayslip.hr_status_flag==1)) && (
                                                                        
                                                                        <Link to={`/hrpayslip-request?id=${hrpayslip.request_id}`}>
                                                                        <i className="fe fe-maximize" />
                                                                        </Link>
                                                                       )}      
                                                                    

                                                                    </td>
                                                                    <td>{pdfbtn}</td>
                                                                    <td>
                                                                        <span>{hrpayslip.payment_id}</span>
                                                                    </td>
                                                                    <td>
                                                                        <span>{hrpayslip.employee_id}</span>
                                                                    </td>
                                                                    <td>
                                                                        <span>{hrpayslip.employee_name}</span>
                                                                    </td>
                                                                    <td>
                                                                        <span>{hrpayslip.department_name}</span>
                                                                    </td>

                                                                    <td>
                                                                        <span>{hrpayslip.month_payment}</span>
                                                                    </td>


                                                                    <td>
                                                                        <span>{hrpayslip.applied_on}</span>
                                                                    </td>

                                                                    <td>
                                                                        <span>{hrpayslip.reason}</span>
                                                                    </td>

                                                                

                                                                    <td>
                                                                        <span>{ReactHtmlParser(hrpayslip.incharge_status)}</span>
                                                                    </td>


                                                                    <td>
                                                                        <span>{ReactHtmlParser(hrpayslip.hod_status)}</span>
                                                                    </td>

                                                                    <td>
                                                                        <span>{ReactHtmlParser(hrpayslip.hr_status)}</span>
                                                                    </td>

                                                                    
                                                                </tr>


                                                            })
                                                        }

                                                    </tbody>
                                                </table>
                                            </div>



                                            <Pagination
												currentPage={currentPage}
												totalPages={totalPages}
												onPageChange={setCurrentPage}
												/>









                                        </div>
                                    </div>
                                </div>


                            </div>
                        </div>
                    </div>

                </div>
            </div>





            
            






        </>
    );

}



const mapStateToProps = (state) => ({
    fixNavbar: state.settings.isFixNavbar,
    statisticsOpen: state.settings.isStatistics,
    statisticsClose: state.settings.isStatisticsClose,
})

const mapDispatchToProps = (dispatch) => ({
    statisticsAction: (e) => dispatch(statisticsAction(e)),
    statisticsCloseAction: (e) => dispatch(statisticsCloseAction(e))
})
export default connect(mapStateToProps, mapDispatchToProps)(HrListPaylip);